export default "__VITE_ASSET__e5c5812d__"